<script>
import { getClass } from "@/api";
import Breadcrumbs from "../components/global/breadcrumbs.vue";
import ClassForm from "@/components/classes/class_form.vue";

export default {
  name: "EditClassView",
  components: {
    Breadcrumbs,
    ClassForm,
  },
  data() {
    return {
      loading: true,
      error: "",
      classData: null,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t("classes.classes"),
          to: "/classes",
        },
        {
          text: this.classData?.name || this.$t("classes.viewClass"),
          to: `/class/${this.classData.id}`,
        },
        {
          text: this.$t("common.edit"),
          active: true,
        },
      ];
    },
  },
  async mounted() {
    try {
      const { data } = await getClass(this.$route.params.id);

      this.classData = data.classData;

      this.loading = false;
      this.error = "";
    } catch (error) {
      this.loading = false;
      this.error = error.response?.data?.error;
    }
  },
};
</script>

<template>
  <eg-b-container>
    <section>
      <eg-b-row v-if="loading || error">
        <eg-b-col>
          <eg-b-spinner v-if="loading"></eg-b-spinner>
          <eg-b-alert v-if="error" variant="danger" show>{{
            error
          }}</eg-b-alert>
        </eg-b-col>
      </eg-b-row>
      <template v-else>
        <breadcrumbs :items="breadcrumbs" />
        <eg-b-row>
          <eg-b-col lg="6">
            <h1>{{ $t("classes.editClass") }}</h1>
          </eg-b-col>
        </eg-b-row>
        <class-form
          editing
          :class-id="classData.id"
          :class-name="classData.name"
          :class-description="classData.description"
          :class-size="classData.size"
          :button-text="$t('rubrics.saveChanges')"
        />
      </template>
    </section>
  </eg-b-container>
</template>
